import React, { useState, useEffect } from 'react';
import './FAQ.css';

const FAQ: React.FC = () => {
  const [activeTab, setActiveTab] = useState('order');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="faq-page">
      <div className="faq-container">
        
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about orders, returns, refunds, and payments.</p>
        </div>

        <div className="faq-tabs-container">
          <div 
            className={`faq-tab ${activeTab === 'order' ? 'selectedTab' : ''}`}
            onClick={() => setActiveTab('order')}
          >
            Order Tracking
          </div>
          <div 
            className={`faq-tab ${activeTab === 'return' ? 'selectedTab' : ''}`}
            onClick={() => setActiveTab('return')}
          >
            Customer Return Policy
          </div>
          <div 
            className={`faq-tab ${activeTab === 'refund' ? 'selectedTab' : ''}`}
            onClick={() => setActiveTab('refund')}
          >
            Refund
          </div>
          <div 
            className={`faq-tab ${activeTab === 'payment' ? 'selectedTab' : ''}`}
            onClick={() => setActiveTab('payment')}
          >
            Payment Options
          </div>
        </div>

        <div className="faq-content-wrap">
          {activeTab === 'order' && (
            <div className="faq-text-wrap">
              <h2 className="faq-heading-txt pt-0">How do I place an order?</h2>
              <p>Ordering at Industrybull is easy. Placing your first order at Industrybull? Please follow the below mentioned steps:</p>
              <div className="faq-list-data">
                <span>Just select the items you want to shop.</span>
                <span>Enter your shipping address.</span>
                <span>Enter your payment information and you are home.</span>
                <span>If you need any assistance give us a call. We would love to take your order over phone. You may contact us on +91 8448 233 444 to book your order on COD mode. Call Timings: 10:30 AM - 4:30 PM (Monday to Saturday)</span>
              </div>
              
              <h2 className="faq-heading-txt">Does Industrybull sell the products?</h2>
              <p>All the products on this website are sold by the suppliers registered with Industrybull directly to the customers. Industrybull provides only the marketplace services to its customers and suppliers. Industrybull protects the interests of its buyers under buyer protection policy. More more details, please read our FAQs.</p>
              
              <h2 className="faq-heading-txt">How will my order be delivered to me?</h2>
              <p>Your order would be delivered through reputed courier companies at your doorstep. Bulk Orders (greater than 10) & heavy items are shipped through surface & may take more than 10 days for delivery.</p>
              
              <h2 className="faq-heading-txt">How will I know if order is placed successfully?</h2>
              <p>Once your Order is successfully placed, you will receive a confirmation over email and text message from Industrybull.com. This mail will have all the details related to your order. Order details can also be viewed at My Account &gt; Order history, if you have placed the order through your log in id.</p>
              
              <h2 className="faq-heading-txt">What is Platform Fee & 24 Hours/Next Day Delivery Fee?</h2>
              <p><b>Platform Fee:</b> Industrybull charges a fee that is non-refundable in case of cancellation/return to maintain the platform and ensure a smooth user experience.</p>
              <p><b>24 Hours/Next Day Delivery Fee:</b> This fee ensures faster shipping. Non-refundable in case of cancellation/return.</p>
              <p><b>Refund of platform fee/24 Hours/Next Day Delivery Fee:</b></p>
              <div className="faq-list-data">
                <span>If the order is lost before delivery, the complete order amount will be refunded if paid online, including the platform fee.</span>
                <span>If a customer cancels an order partially/fully or returns/exchange an order, platform charges will not be refunded.</span>
                <span>If there is order cancellation from Industrybull end, platform charges will be refunded.</span>
              </div>
              
              <h2 className="faq-heading-txt">What is the standard delivery time?</h2>
              <p>Standard delivery time is 2-4 days, however for some products delivery time may vary depending upon the availability or depending upon the size of the order.</p>
              
              <h2 className="faq-heading-txt">Why is standard delivery time different for some products?</h2>
              <p>Time taken to deliver a product depends upon the below mentioned parameters:</p>
              <div className="faq-list-data">
                <span>Stock availability</span>
                <span>Size of the order</span>
                <span>Shipping Address</span>
                <span>Size of the product</span>
                <span>Make to Order products</span>
              </div>
            </div>
          )}

          {activeTab === 'return' && (
            <div className="faq-text-wrap">
              <p>Industrybull is happy to serve customer and fulfil their requirements. If customer receives any product which fulfils the below mentioned criterion, customer is eligible for return / exchange:</p>
              <div className="faq-list-data">
                <span>Product is used/altered/Defective product.</span>
                <span>Physical / in-transit damage to the product.</span>
                <span>Branded product received seal opened.</span>
                <span>Empty packet/some items or accessories are missing.</span>
                <span>Significant difference found in Industrybull website as comparison to product.</span>
              </div>
              
              <h2 className="faq-heading-txt">Customer is not eligible for return/exchange if</h2>
              <div className="faq-list-data">
                <span>Its “No longer needed”.</span>
                <span>Customer tried to handle the industrial product and unable to use it which promotes any tear/damage.</span>
                <span>Made to Product(on demand) will not be returned.</span>
                <span>Office Chair Return/Exchange Policy- Please note that returns or exchanges are not applicable for office chairs. However, in the event that the chair arrives with a broken part or missing accessory, we will promptly dispatch the required replacement part(s) to your specified location at no additional cost.</span>
              </div>
              
              <h2 className="faq-heading-txt">Guidelines for Return/Exchange:</h2>
              <div className="faq-list-data">
                <span>For Products purchased on Industrybull, in the event the customer has any concern with the Product, the customer shall inform to Industrybull Customer care within 48 Hours of product delivery.</span>
                <span>Customer must share video with Customer care team while opening the package in case of Empty Package/Quantity issue.</span>
                <span>Customer need to share 7-8 images of the Complete product, Product packaging/box (Outer & Inner) & Shipment label while raising the Return or Replacement request.</span>
                <span>In case of Industrial goods return will be accepted only in case of wrong, defective, damaged product.</span>
                <span>In Case of Faulty electronics product, customer need to contact nearest service centre for repair/ replacement.</span>
                <span>All products must be in new and unopened condition with all the original packing, tags, inbox literature, warranty/ guarantee card, freebies and accessories including keys, straps and locks intact.</span>
                <span>Industrybull shall endeavour to process the customer refund within 7 (Seven) working days from the date of request made to the Customer Care team.</span>
              </div>
              
              <h2 className="faq-heading-txt">Below Mentioned products are non-returnable:</h2>
              <div className="faq-table-wrap">
                <table>
                  <tbody>
                    <tr>
                      <td>Category</td>
                      <td>Product Type</td>
                    </tr>
                    <tr>
                      <td>Automotive</td>
                      <td>Lubricants, greases, oils, waxes, polishes & other liquid.</td>
                    </tr>
                    <tr>
                      <td>Medical or Lab Supplies</td>
                      <td>No return policy against any issue.</td>
                    </tr>
                    <tr>
                      <td>Tapes, Adhesives, Sealants, Welding, Paints</td>
                      <td>Adhesives (all liquids), hazardous materials and lubricants.</td>
                    </tr>
                    <tr>
                      <td>Electricals</td>
                      <td>Refunds will not be initiated on electrical / Electronic products / large appliances.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'refund' && (
            <div className="faq-text-wrap">
              <h2 className="faq-heading-txt pt-0">I've still not received the refund to my bank account. Why?</h2>
              <p>If you have received a mail/message from us confirming your refund request then rest assured that we have initiated your refund request and are following up with financial organisations for the same.</p>
              <p>Sometimes financial organisations take a longer time to process the refund request. However, if the refund hasn't happened by the date we promised, you can contact us. We will gladly help you.</p>
              
              <h2 className="faq-heading-txt">When are Refunds provided?</h2>
              <p>We work to provide the most hassle-free online shopping experience. You are covered and your money safe. We initiate the refund process as soon as we receive the details.</p>
              <div className="faq-list-data">
                <span>Damaged products are returned to our warehouse and has been quality checked.</span>
              </div>
              
              <h2 className="faq-heading-txt">I paid the amount upfront while purchasing product from Industrybull, how do I get the refund?</h2>
              <p>Your payment is secured. In case of prepaid orders (paid through credit card/debit card/net banking), the amount is refunded in the same account as you had made payment from within 7-10 working days.</p>
              
              <h2 className="faq-heading-txt">I paid cash on delivery, how would I get the refund?</h2>
              <p>If the mode of payment was cash on delivery (COD), we will initiate a NEFT bank transfer to your bank account. Industrybull will contact you for your bank account details. It normally takes 7-10 days for your money to get reflected in your bank account.</p>
            </div>
          )}

          {activeTab === 'payment' && (
            <div className="faq-text-wrap">
              <h2 className="faq-heading-txt pt-0">What are the modes of payment for purchasing on Industrybull.com? What payment methods do you accept?</h2>
              <p>We accept the following modes of payment:</p>
              <div className="faq-list-data">
                <span>Debit/Credit Cards/Net banking of all major banks</span>
                <span>Cash On Delivery (COD)</span>
                <span>NEFT/RTGS</span>
              </div>
              
              <h2 className="faq-heading-txt">What is COD (Cash On Delivery)? Are there any additional charges for COD orders?</h2>
              <div className="faq-list-data">
                <span>COD refers to Cash On Delivery. It doesn’t matter if you don’t have a Credit/Debit card or online shopping is not your forte. If you are not comfortable making an online payment on Industrybull.com, you can opt for the Cash on Delivery (C-o-D) payment method instead. Industrybull offers you the option of paying for the purchase at your doorstep. Just place your order and make cash payment to our COD partner upon the delivery of your item.</span>
                <span>Not all deals/products have COD option. Please check the deal page before buying. Industrybull does not offer COD at all locations. Please enter your pin code to check the availability of COD option at your location.</span>
              </div>
              
              <h2 className="faq-heading-txt">Is it safe to use my credit/debit card on Industrybull?</h2>
              <div className="faq-list-data">
                <span>Your online transaction on Industrybull is secure with the highest levels of transaction security currently available on the Internet. Industrybull uses a secure payment gateway to protect your card information while securely transmitting it to the respective banks for payment processing.</span>
                <span>All credit card and debit card payments on Industrybull are processed through secure and trusted payment gateways managed by leading banks. Banks now use the 3D secure password service for online transactions, providing an additional layer of security through identity verification.</span>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default FAQ;
